import { useEffect } from 'react';
import i18n from '@/lib/i18n';

/**
 * Wraps a /ar/* route (router.tsx) so the page it renders is genuinely in
 * Arabic the moment a crawler (or a person, via a shared link) lands on
 * it -- Googlebot never executes the header's manual toggle, so a real,
 * server-distinguishable URL is the only way an Arabic-language search
 * result can point at Arabic content. Same i18n.changeLanguage() the
 * header's own toggle already calls, so this also persists as the site's
 * language for the rest of that visit, matching how the toggle already
 * behaves everywhere else.
 */
export function ForceLocale({ lang, children }: { lang: 'en' | 'ar'; children: React.ReactNode }) {
  useEffect(() => {
    if (i18n.language !== lang) i18n.changeLanguage(lang);
  }, [lang]);
  return <>{children}</>;
}
